@import 'vars';

.hello {
  display: flex;
  flex-direction: column;
  height: fit-content;
  max-width: 600px;

  &--softphone {
    flex: 1;
    min-width: 100%;
    gap: 20px;
  }

  &__black-anchor {
    color: $black !important;
  }

  &__extended-load {
    min-height: 0;
    height: 0;
    overflow: hidden;
    transition: all 0.3s ease-in-out;

    hr {
      margin: 0;
      margin-bottom: 20px;
    }

    &--expanded {
      min-height: 120px;
    }
  }

  &__buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}
